import { useCallback } from 'react';
import { useIsDeveloper } from 'src/hooks/useIsDeveloper';
import { setSnackbar, clearSnackbar } from 'src/store/actions/ui';
import type { SnackbarMessage, SnackbarOptions } from 'src/store/actions/ui';
import { useDispatch } from 'src/store/hooks';

export interface ResponseData {
    requestId?: string;
    debugMessage?: string;
}

export const useSnackbar = () => {
    const dispatch = useDispatch();
    const isDev = useIsDeveloper();

    const enqueueSnackbar = useCallback(
        (message: SnackbarMessage, options?: SnackbarOptions, responseData?: ResponseData) => {
            // Pass requestId and debugMessage (if dev) through options for serializable Redux state
            // The toast renderer will construct the UI from these serializable props
            dispatch(
                setSnackbar(message, {
                    ...options,
                    requestId: responseData?.requestId,
                    debugMessage: isDev ? responseData?.debugMessage : undefined,
                }),
            );
        },
        [dispatch, isDev],
    );

    const closeSnackbar = useCallback(() => {
        dispatch(clearSnackbar());
    }, [dispatch]);

    return { enqueueSnackbar, closeSnackbar };
};
